module.exports = __webpack_public_path__ + "img/Logo-Inflow-Hor-WB.a9675a29.png";